import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';

import { HasPermissionDirective } from '../directive/has-permission.directive';
import { SafeHtmlPipe } from './../pipe/safe-html.pipe';
import { TableReflowDirective } from '../directives/table-reflow.directive';
import { LoaderComponent } from './loader/loader.component';
import { CustomValidation } from '../helpers/customValidation';
import { MinuteVoteDetailComponent } from './minute-vote-detail/minute-vote-detail.component';

@NgModule({
  declarations: [
    HasPermissionDirective,
    SafeHtmlPipe,
    TableReflowDirective,
    LoaderComponent,
    MinuteVoteDetailComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule
  ],
  providers: [
    CustomValidation
  ],
  exports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    HasPermissionDirective,
    SafeHtmlPipe,
    TableReflowDirective,
    LoaderComponent,
    MinuteVoteDetailComponent,
  ]
})
export class SharedModule { }
